import React from 'react';
import cn from 'classnames';
import { Icon } from './Icon';
import { IconMap } from '../sprite';

const styles = {
  base: 'flex flex-nowrap items-center gap-x-1.5 py-1.5 px-2 rounded-lg text-sm font-medium focus:outline-none',
  active: 'bg-base-white shadow-sm text-gray-700',
  inActive:
    'hover:bg-base-white hover:shadow-sm text-gray-500 hover:text-gray-700',
} as const;

export type SwitchGridListValue = 'grid' | 'list';

type Props = {
  value: SwitchGridListValue;
  onChange: (value: SwitchGridListValue) => void;
  className?: string;
};

export const SwitchGridList: React.FC<Props> = ({
  value,
  onChange,
  className,
}) => {
  return (
    <div
      className={cn(
        'flex flex-nowrap items-center p-1 gap-0.5 rounded-xl bg-base-black/[0.08]',
        className
      )}
    >
      <button
        type="button"
        onClick={() => onChange('grid')}
        className={cn(styles.base, {
          [styles.active]: value === 'grid',
          [styles.inActive]: value !== 'grid',
        })}
      >
        <Icon glyph={IconMap.Grid01} width={20} />
        Grid
      </button>
      <button
        type="button"
        onClick={() => onChange('list')}
        className={cn(styles.base, {
          [styles.active]: value === 'list',
          [styles.inActive]: value !== 'list',
        })}
      >
        <Icon glyph={IconMap.List02} width={20} />
        List
      </button>
    </div>
  );
};
